var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.272 1.365C5.96046e-08 1.9 0 2.6 0 4V10C0 11.4 5.96046e-08 12.1 0.272 12.635C0.511895 13.1053 0.894506 13.4875 1.365 13.727C1.9 14 2.6 14 4 14H16C17.4 14 18.1 14 18.635 13.727C19.1051 13.4874 19.4874 13.1051 19.727 12.635C20 12.1 20 11.4 20 10V4C20 2.6 20 1.9 19.727 1.365C19.4875 0.894506 19.1053 0.511895 18.635 0.272C18.1 -1.78814e-07 17.4 0 16 0H4C2.6 0 1.9 -1.78814e-07 1.365 0.272C0.894354 0.511725 0.511725 0.894354 0.272 1.365ZM2.647 2H17.353C17.4604 1.99987 17.5649 2.0343 17.6512 2.09819C17.7375 2.16209 17.8009 2.25206 17.8321 2.35479C17.8632 2.45753 17.8605 2.56757 17.8243 2.66864C17.7881 2.76971 17.7203 2.85644 17.631 2.916L10.556 7.648C10.3915 7.75806 10.198 7.81682 10 7.81682C9.80204 7.81682 9.60854 7.75806 9.444 7.648L2.369 2.916C2.27968 2.85644 2.21189 2.76971 2.17568 2.66864C2.13947 2.56757 2.13676 2.45753 2.16794 2.35479C2.19912 2.25206 2.26253 2.16209 2.34881 2.09819C2.43509 2.0343 2.53964 1.99987 2.647 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.542cc1941720db94cb7e1e3cab61403c.svg";
export { ForwardRef as ReactComponent };